import { useMemo } from "react";
import { useDraft } from "./useDraft";

export function useNewAccounts() {
    const { draftEdits } = useDraft();
    return useMemo(() => draftEdits.rows || {}, [draftEdits.rows]);
}
